import { autoinject, bindable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { FormattingHelper } from '../../helpers/formatting-helper';

@autoinject
export class AccountSummary {
	@bindable accountNumberLabel: string;
	@bindable accountNumber: string;
	@bindable balance: number;
	@bindable balanceLabel: string;
	@bindable minPayment: number;
	@bindable enforceMinPayment: boolean;
	@bindable showBalance: boolean;
	@bindable accountDescriptionLabel: string;
	@bindable accountDescription: string;
	@bindable tryToDisplayMinPaymentDue: boolean;
	@bindable displayMinimumPaymentAmountOnPortal: boolean;

	minimumPaymentAmountMesssage: string;

	constructor(private i18n: I18N) {
	}

	attached() {
		if (this.tryToDisplayMinPaymentDue &&
			this.displayMinimumPaymentAmountOnPortal &&
			this.minPayment) {
			this.minimumPaymentAmountMesssage = this.i18n.i18next.t('minimumPaymentOfXDueOnAccount', {
				defaultValue: `A minimum payment of ${FormattingHelper.formatCurrency(this.minPayment)} is due on this account.`,
				paymentAmount: FormattingHelper.formatCurrency(this.minPayment)
			});
		}
	}
}